import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SignatureField } from 'clayco-controls';

const LegalText = () => {
    const { t } = useTranslation();
    const signatureRef = useRef(null);

    useEffect(() => {
        const canvas = signatureRef.current?.querySelector('canvas');

        const handleTouchStart = (e) => {
            e.preventDefault(); // Prevent scroll jump
        };

        if (canvas) {
            canvas.addEventListener('touchstart', handleTouchStart, { passive: false });
        }

        return () => {
            if (canvas) {
                canvas.removeEventListener('touchstart', handleTouchStart);
            }
        };
    }, []);

    return (
        <div
            style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                padding: '16px',
                marginTop: '16px',
                marginBottom: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
        >
            <p>{t('ClaycoLegal1')}</p>

            <ul style={{ listStyleType: 'disc', paddingLeft: '32px' }}>
                <li>{t(`Clayco's Mandatory Safety Work Rules`)}</li>
                <li>{t(`Clayco's Substance Abuse Policy`)}</li>
                <li>{t('ClaycoLegal2')}</li>
            </ul>

            <p>{t('ClaycoLegal3')}</p>
            <p>{t('ClaycoLegal4')}</p>
            <p>{t('CovidPolicy')}</p>
            <p>{t('ClaycoLegal5')}</p>

            <div
                ref={signatureRef}
                style={{
                    marginTop: '16px',
                }}
            >
                <label
                    style={{
                        display: 'block',
                        fontWeight: '600',
                        marginBottom: '8px',
                    }}
                >
                    {t('Signature')}
                </label>
                <div
                    style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        padding: '10px',
                        touchAction: 'none',
                    }}
                >
                    <SignatureField
                        formFieldName={'signature'}
                        clearText={t('Clear')}
                    />
                </div>
            </div>
        </div>
    );
};

export default LegalText;